/* eslint-disable import/no-anonymous-default-export */
const authState = {
  isLogin: false,
  isRegister: false,
  token: '',
  isLoading: false,
  isError: false,
  alertMsg: '',
  level: 0,
  listRoute: [
        { route: 'master/dokumen', level: [1] },
        { route: 'email', level: [1] },
        { route: 'pic', level: [1] },
        { route: 'user', level: [1] },
        { route: 'depo', level: [1] },
        { route: 'divisi', level: [1] },
        { route: 'inventory', level: [1] },
    ]
}

export default (state = authState, action) => {
  switch (action.type) {

    case 'AUTH_USER_PENDING': {
      return { ...state, isLoading: true, alertMsg: 'Login in ....' }
    }

    case 'AUTH_USER_FULFILLED': {
      const { user, access_token, refresh_token } = action.payload.data

      localStorage.setItem('token', access_token)
      localStorage.setItem('refresh_token', refresh_token)
      localStorage.setItem('level', user.user_level)
      localStorage.setItem('name', user.username)
      localStorage.setItem('kode', user.kode_depo)
      localStorage.setItem('id', user.id)

      return {
        ...state,
        level: user.user_level,
        isLogin: true,
        isError: false,
        isLoading: false,
        token: access_token,
        alertMsg: 'Login Successfully'
      }
    }

    case 'AUTH_USER_REJECTED': {
      return { ...state, isLoading: false, isLogin: false, isError: true, alertMsg: 'Login Failed' }
    }

    // ── refresh token ────────────────────────────────────────────────────────
    case 'REFRESH_TOKEN_FULFILLED': {
      const { access_token, refresh_token } = action.payload.data

      localStorage.setItem('token', access_token)
      localStorage.setItem('refresh_token', refresh_token)

      return { ...state, token: access_token, isLogin: true }
    }

    case 'REFRESH_TOKEN_REJECTED': {
      localStorage.clear()
      return { ...authState, isLogin: false }
    }

    case 'SET_TOKEN': {
      return { ...state, token: action.payload.token, isLogin: true }
    }

    case 'LOGOUT': {
      localStorage.clear()
      return { ...authState }
    }

    case 'RESET': {
      return { ...state, isLogin: false }
    }

    default:
      return state
  }
}